import { FadeIn } from "@/components/Reveal";

/** Shared hero band for interior marketing pages. */
export const PageHero = ({ eyebrow, title, copy, children, testid }) => (
  <section className="noise-dark relative overflow-hidden bg-navydeep py-20 text-white lg:py-28" data-testid={testid}>
    <div
      aria-hidden="true"
      className="pointer-events-none absolute -right-40 -top-24 h-[480px] w-[480px] rounded-full border border-teal/25"
    />
    <div
      aria-hidden="true"
      className="pointer-events-none absolute -right-28 -top-12 h-[350px] w-[350px] rounded-full border border-amber/20"
    />
    <div className="container-tsm relative max-w-[1200px]">
      <FadeIn>
        <p className="eyebrow">{eyebrow}</p>
        <h1 className="mt-7 max-w-4xl text-4xl font-extrabold leading-[1.06] tracking-tight sm:text-5xl lg:text-6xl" data-testid={`${testid}-headline`}>
          {title}
        </h1>
        {copy && <p className="mt-7 max-w-2xl text-lg leading-relaxed text-white/70" data-testid={`${testid}-copy`}>{copy}</p>}
        {children}
      </FadeIn>
    </div>
  </section>
);
